import {createContext} from 'react'
import type {Project} from '@package/shared'
import type {AddProjectRequest, UpdateProjectRequest} from '@app/api-resolver/router'

export type ProjectsContextValue = {
  projects: Project[]
  activeProjects: Project[]
  archivedProjects: Project[]
  loading: boolean

  addProject: (project: AddProjectRequest) => Promise<Project>
  updateProject: (project: UpdateProjectRequest) => Promise<Project>
  archiveProject: (projectId: Project['id']) => Promise<Project>
  unarchiveProject: (projectId: Project['id']) => Promise<Project>
  saving: boolean
}

export const ProjectsContext = createContext<ProjectsContextValue>({} as ProjectsContextValue)
